export default __webpack_public_path__ + "static/media/P-028.1c293259.png";